mergeObjects